/*
 *  Copyright (c) Qwoach LLC 2022. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 29/7/2022
 */


import BaseObject from "@shared/BaseObject";
import {Type} from "@qwoach/class-transformer-wrapper"
import CoachingPackageTemplate from "@shared/CoachingPackage/CoachingPackageTemplate";
import UserProfile from "@shared/Profile/UserProfile";
import PurchasedCoachingPackage from "@shared/CoachingPackage/PurchasedCoachingPackage";

export default class CoachingPackageInfo extends BaseObject {

	@Type(() => CoachingPackageTemplate)
	coachingPackageTemplate: CoachingPackageTemplate = null

	@Type(() => PurchasedCoachingPackage)
	coachingPackageItem: PurchasedCoachingPackage = null

	@Type(() => UserProfile)
	coachProfile: UserProfile = null

}
